import { atom } from "jotai";

export const StudySelectedIdAtom = atom<string | null>(null);
